module.exports = __webpack_public_path__ + "img/355.f6c8ec1d.jpg";